
import { User, Wedding, Plan, SubscriptionStatus } from './types';

// --- SEED DATA ---
const SEED_WEDDINGS = [
  {
    id: '00000000-0000-0000-0000-000000000000',
    title: 'Svatba Anny & Petra',
    date: '2025-06-20',
    location: 'Zámek Hluboká',
    public_slug: 'anna-petr-2025',
    welcome_message: 'Vítejte na stránkách naší svatby! Těšíme se, že tento den oslavíte s námi.',
    owner_user_id: 'debug-user-id',
    default_language: 'cs',
    plan: 'PRO',
    subscriptionStatus: 'ACTIVE',
    public_enabled: true,
    is_free_tier: false,
    publicConfig: { showSchedule: true, showFaq: true, welcomeMessage: 'Vítejte!' },
    vendor_types: [
      'Fotograf',
      'Místo',
      'Hudba',
      'Květiny',
      'Jídlo - Oběd',
      'Jídlo - Raut',
      'Jídlo - Zákusky',
      'Jídlo - Večeře',
      'Video',
      'Vizážistka',
      'Doprava',
      'Ostatní'
    ]
  }
];

const SEED_GUESTS = [
  { id: 'g1', wedding_id: '00000000-0000-0000-0000-000000000000', full_name: 'Jan Novák', rsvp_status: 'confirmed', plus_one: true, kids_count: 0, side: 'groom', role: 'witness', allergies: 'Ořechy', created_at: '2023-12-01T10:00:00Z' },
  { id: 'g2', wedding_id: '00000000-0000-0000-0000-000000000000', full_name: 'Marie Svobodová', rsvp_status: 'confirmed', plus_one: false, kids_count: 1, side: 'groom', role: 'guest', created_at: '2023-12-02T11:30:00Z' },
  { id: 'g3', wedding_id: '00000000-0000-0000-0000-000000000000', full_name: 'Petr Černý', rsvp_status: 'pending', plus_one: false, kids_count: 0, side: 'bride', role: 'witness', allergies: 'Lepek', created_at: '2023-12-05T09:00:00Z' },
  { id: 'g4', wedding_id: '00000000-0000-0000-0000-000000000000', full_name: 'Anna Bílá', rsvp_status: 'declined', plus_one: false, kids_count: 0, side: 'bride', role: 'bridesmaid', created_at: '2023-12-06T14:20:00Z' },
  { id: 'g5', wedding_id: '00000000-0000-0000-0000-000000000000', full_name: 'Karel Dvořák', rsvp_status: 'confirmed', plus_one: true, kids_count: 2, side: 'groom', role: 'parent', created_at: '2023-12-07T16:00:00Z' },
  { id: 'g6', wedding_id: '00000000-0000-0000-0000-000000000000', full_name: 'Lucie Krátká', rsvp_status: 'pending', plus_one: true, kids_count: 0, side: 'bride', role: 'bridesmaid', created_at: '2023-12-08T10:00:00Z' },
  { id: 'g7', wedding_id: '00000000-0000-0000-0000-000000000000', full_name: 'Tomáš Veselý', rsvp_status: 'confirmed', plus_one: false, kids_count: 0, side: 'mutual', role: 'guest', created_at: '2023-12-10T11:00:00Z' },
  { id: 'g8', wedding_id: '00000000-0000-0000-0000-000000000000', full_name: 'Jana Malá', rsvp_status: 'pending', plus_one: false, kids_count: 0, side: 'mutual', role: 'guest', created_at: '2023-12-11T13:00:00Z' }
];

const SEED_TASKS = [
  { id: 't1', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Rezervace místa (Zámek)', phase: 'early', due_date: '2024-06-01', status: 'done' },
  { id: 't2', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Výběr fotografa', phase: 'early', due_date: '2024-07-15', status: 'done' },
  { id: 't3', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Sestavení menu', phase: 'mid', due_date: '2024-12-01', status: 'in_progress' },
  { id: 't4', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Rozeslání pozvánek', phase: 'approaching', due_date: '2025-03-01', status: 'todo' },
  { id: 't5', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Zkouška šatů', phase: 'mid', due_date: '2024-11-20', status: 'done' },
  { id: 't6', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Objednání květin', phase: 'approaching', due_date: '2025-04-01', status: 'todo' },
  { id: 't7', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Zasedací pořádek', phase: 'final', due_date: '2025-05-20', status: 'todo' },
  { id: 't8', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Playlist pro DJe', phase: 'final', due_date: '2025-06-01', status: 'todo' }
];

const SEED_SCHEDULE = [
  { id: 's1', wedding_id: '00000000-0000-0000-0000-000000000000', start_time: '10:00:00', title: 'Přípravy nevěsty', location: 'Apartmá Zámek', is_public: false, notes: 'Pouze pro družičky a rodinu' },
  { id: 's2', wedding_id: '00000000-0000-0000-0000-000000000000', start_time: '12:00:00', title: 'Svatební obřad', location: 'Zámecká zahrada', is_public: true, notes: 'Prosíme hosty, aby dorazili alespoň 15 minut předem' },
  { id: 's3', wedding_id: '00000000-0000-0000-0000-000000000000', start_time: '13:00:00', title: 'Společné focení', location: 'Před zámkem', is_public: true },
  { id: 's4', wedding_id: '00000000-0000-0000-0000-000000000000', start_time: '14:30:00', title: 'Slavnostní oběd', location: 'Velký sál', is_public: true },
  { id: 's5', wedding_id: '00000000-0000-0000-0000-000000000000', start_time: '17:00:00', title: 'Krájení dortu', location: 'Terasa', is_public: true },
  { id: 's6', wedding_id: '00000000-0000-0000-0000-000000000000', start_time: '19:00:00', title: 'První tanec', location: 'Taneční parket', is_public: true },
  { id: 's7', wedding_id: '00000000-0000-0000-0000-000000000000', start_time: '22:00:00', title: 'Ohňostroj', location: 'Zahrada', is_public: true }
];

const SEED_ACTIVITIES = [
  { id: 'a1', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Fotokoutek', type: 'planned', status: 'approved', is_all_day: true, description: 'K dispozici v hlavním sále po celý večer.', votes_up: 5, votes_down: 0 },
  { id: 'a2', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Hudební doprovod (DJ)', type: 'planned', status: 'approved', is_all_day: false, start_time: '18:00:00', end_time: '02:00:00', description: 'Taneční zábava s DJ Tomášem.', votes_up: 10, votes_down: 0 },
  { id: 'a3', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Svatební kvíz', type: 'planned', status: 'approved', is_all_day: false, start_time: '16:00:00', description: 'Kvíz o novomanželích pro hosty.', votes_up: 8, votes_down: 1 },
  { id: 'a4', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Karaoke', type: 'proposal', status: 'draft', is_all_day: false, description: 'Navrhuji karaoke po půlnoci!', votes_up: 3, votes_down: 2 },
  { id: 'a5', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Prskavkový tanec', type: 'proposal', status: 'draft', is_all_day: false, description: 'Tanec venku s prskavkami.', votes_up: 12, votes_down: 0 },
];

const SEED_BUDGET = [
  // Linked items
  { id: 'b1', wedding_id: '00000000-0000-0000-0000-000000000000', category: 'Místo', title: 'Zámek Hluboká', planned_amount: 50000, paid_amount: 50000, source_type: 'vendor', source_id: 'v1', include_in_budget: true },
  { id: 'b2', wedding_id: '00000000-0000-0000-0000-000000000000', category: 'Jídlo - Oběd', title: 'Lahůdky s.r.o.', planned_amount: 135000, paid_amount: 40000, source_type: 'vendor', source_id: 'v3', include_in_budget: true },
  { id: 'b3', wedding_id: '00000000-0000-0000-0000-000000000000', category: 'Oblečení', title: 'Svatební šaty', planned_amount: 20000, paid_amount: 22000, source_type: 'manual', include_in_budget: true },
  { id: 'b4', wedding_id: '00000000-0000-0000-0000-000000000000', category: 'Fotograf', title: 'Tomáš Světlo', planned_amount: 28000, paid_amount: 10000, source_type: 'vendor', source_id: 'v_photo1', include_in_budget: true },
  { id: 'b5', wedding_id: '00000000-0000-0000-0000-000000000000', category: 'Hudba', title: 'DJ Párty', planned_amount: 15000, paid_amount: 5000, source_type: 'vendor', source_id: 'v5', include_in_budget: true },
  { id: 'b6', wedding_id: '00000000-0000-0000-0000-000000000000', category: 'Dekorace & Květiny', title: 'Květinová výzdoba', planned_amount: 30000, paid_amount: 0, source_type: 'manual', include_in_budget: true },
  { id: 'b7', wedding_id: '00000000-0000-0000-0000-000000000000', category: 'Prstýnky', title: 'Prstýnek – Nevěsta (Zlatý kroužek)', planned_amount: 15000, paid_amount: 14500, source_type: 'ring', source_id: 'r1', include_in_budget: true }
];

const SEED_VENDORS = [
  // Photographers
  { id: 'v_photo1', wedding_id: '00000000-0000-0000-0000-000000000000', type: 'Fotograf', name: 'Tomáš Světlo', status: 'booked', contact_email: 'tomas@svetlo.cz', price_estimate: 28000, paid_amount: 10000, notes: 'Záloha zaplacena' },
  { id: 'v_photo2', wedding_id: '00000000-0000-0000-0000-000000000000', type: 'Fotograf', name: 'Jan Cvak', status: 'potential', contact_email: 'jan@cvak.cz', price_estimate: 22000, paid_amount: 0, notes: 'Líbí se nám portfolio' },
  
  // Other vendors mapped to new categories
  { id: 'v1', wedding_id: '00000000-0000-0000-0000-000000000000', type: 'Místo', name: 'Zámek Hluboká', status: 'booked', contact_email: 'info@zamek.cz', price_estimate: 50000, paid_amount: 50000, contact_phone: '+420 123 456 789' },
  { id: 'v3', wedding_id: '00000000-0000-0000-0000-000000000000', type: 'Jídlo - Oběd', name: 'Lahůdky s.r.o.', status: 'contacted', contact_email: 'info@lahudky.cz', price_estimate: 135000, paid_amount: 40000 },
  { id: 'v4', wedding_id: '00000000-0000-0000-0000-000000000000', type: 'Květiny', name: 'Květinářství Růže', status: 'potential', contact_email: 'ruze@obchod.cz', price_estimate: 30000, paid_amount: 0 },
  { id: 'v5', wedding_id: '00000000-0000-0000-0000-000000000000', type: 'Hudba', name: 'DJ Párty', status: 'booked', contact_email: 'dj@party.cz', price_estimate: 15000, paid_amount: 5000 },
  { id: 'v6', wedding_id: '00000000-0000-0000-0000-000000000000', type: 'Jídlo - Zákusky', name: 'Sladká Dílna', status: 'potential', contact_email: 'cukr@dilna.cz', price_estimate: 5000, paid_amount: 0 },
  { id: 'v7', wedding_id: '00000000-0000-0000-0000-000000000000', type: 'Jídlo - Raut', name: 'Grill Masters', status: 'potential', contact_email: 'grill@maso.cz', price_estimate: 25000, paid_amount: 0 }
];

const SEED_TABLES = [
  { id: 'tbl1', wedding_id: '00000000-0000-0000-0000-000000000000', name: 'Hlavní stůl', capacity: 6 },
  { id: 'tbl2', wedding_id: '00000000-0000-0000-0000-000000000000', name: 'Rodina Ženicha', capacity: 8 },
  { id: 'tbl3', wedding_id: '00000000-0000-0000-0000-000000000000', name: 'Rodina Nevěsty', capacity: 8 },
  { id: 'tbl4', wedding_id: '00000000-0000-0000-0000-000000000000', name: 'Kamarádi', capacity: 10 }
];

const SEED_ASSIGNMENTS = [
  { wedding_id: '00000000-0000-0000-0000-000000000000', table_id: 'tbl1', guest_id: 'g1' },
  { wedding_id: '00000000-0000-0000-0000-000000000000', table_id: 'tbl1', guest_id: 'g2' },
  { wedding_id: '00000000-0000-0000-0000-000000000000', table_id: 'tbl2', guest_id: 'g5' },
  { wedding_id: '00000000-0000-0000-0000-000000000000', table_id: 'tbl4', guest_id: 'g7' }
];

const SEED_NOTES = [
  { id: 'n1', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Parkování pro hosty', content: 'Parkování je zajištěno přímo v areálu zámku. Kapacita je dostatečná pro 40 vozů.', is_public: true, tags: ['logistika'], created_at: new Date().toISOString() },
  { id: 'n2', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Ubytování', content: 'Hosté si mohou rezervovat pokoje v Hotelu Štekl se slevou 10% pod heslem SVATBA2025.', is_public: true, tags: ['ubytování'], created_at: new Date().toISOString() },
  { id: 'n3', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Dary', content: 'Největší radost nám uděláte svou přítomností. Pokud byste nás chtěli obdarovat, budeme rádi za příspěvek na svatební cestu.', is_public: true, tags: ['dary'], created_at: new Date().toISOString() }
];

const SEED_TEMPLATES = [
  { id: 'tpl1', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Uvítací email', content: 'Ahoj! Jsme moc rádi, že jsi potvrdil účast na naší svatbě. Níže posíláme pár detailů...', language: 'cs', tags: ['email'], created_at: new Date().toISOString() },
  { id: 'tpl2', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Připomenutí RSVP', content: 'Ahoj, blíží se termín pro potvrzení účasti. Dejte nám prosím vědět do konce týdne.', language: 'cs', tags: ['email', 'rsvp'], created_at: new Date().toISOString() }
];

// --- NEW MODULES SEEDS ---

const SEED_RINGS = [
  { id: 'r1', wedding_id: '00000000-0000-0000-0000-000000000000', owner: 'nevesta', ring_type: 'snubni', style_name: 'Zlatý kroužek s brilianty', material: 'Bílé zlato 14k', size: '52', engraving_text: 'Petr 20.6.2025', vendor_name: 'Rýdl', price_estimate: 15000, price_actual: 14500, paid_amount: 14500, status: 'confirmed' },
  { id: 'r2', wedding_id: '00000000-0000-0000-0000-000000000000', owner: 'nevesta', ring_type: 'jiny', style_name: 'Náhradní prsten', material: 'Stříbro', status: 'potential', price_estimate: 2000, price_actual: 0, paid_amount: 0 },
  { id: 'r3', wedding_id: '00000000-0000-0000-0000-000000000000', owner: 'zenich', ring_type: 'snubni', style_name: 'Klasický hladký', material: 'Bílé zlato 14k', size: '62', engraving_text: 'Anna 20.6.2025', vendor_name: 'Rýdl', price_estimate: 12000, price_actual: 0, paid_amount: 0, status: 'potential' }
];

const SEED_CEREMONY_META = [
  { id: 'cm1', wedding_id: '00000000-0000-0000-0000-000000000000', ceremony_type: 'civilni', date: '2025-06-20', start_time: '12:00', location_name: 'Zámecká zahrada', indoor_outdoor: 'outdoor', plan_b_weather: 'V případě deště obřadní síň v 1. patře zámku.' }
];

const SEED_CEREMONY_CONTACTS = [
  { id: 'cc1', wedding_id: '00000000-0000-0000-0000-000000000000', role_type: 'oddavajici', name: 'Mgr. Jan Novotný', org: 'MÚ Hluboká', status: 'confirmed' },
  { id: 'cc2', wedding_id: '00000000-0000-0000-0000-000000000000', role_type: 'matrikarka', name: 'Ivana Dlouhá', phone: '+420 123 456', status: 'confirmed' },
  { id: 'cc3', wedding_id: '00000000-0000-0000-0000-000000000000', role_type: 'hudba', name: 'Smyčcové kvarteto', status: 'potential', price_estimate: 5000, paid_amount: 0 }
];

const SEED_CEREMONY_ROLES = [
  { id: 'cr1', wedding_id: '00000000-0000-0000-0000-000000000000', role_key: 'svedek_zenich', person_name: 'Jan Novák', relationship: 'Bratr', instructions: 'Občanka s sebou, prstýnky v kapse.' },
  { id: 'cr2', wedding_id: '00000000-0000-0000-0000-000000000000', role_key: 'svedek_nevesta', person_name: 'Petr Černý', relationship: 'Kamarád' },
  { id: 'cr3', wedding_id: '00000000-0000-0000-0000-000000000000', role_key: 'kdo_vede_nevestu', person_name: 'Karel (Otec)', relationship: 'Otec', instructions: 'Předat nevěstu, políbit na tvář, podat ruku ženichovi.' }
];

const SEED_CEREMONY_STEPS = [
  { id: 'cs1', wedding_id: '00000000-0000-0000-0000-000000000000', order_index: 1, step_name: 'Příchod ženicha', description: 'Ženich přichází s maminkou.', participants: ['zenich'], cue: 'Hudba: Canon in D' },
  { id: 'cs2', wedding_id: '00000000-0000-0000-0000-000000000000', order_index: 2, step_name: 'Příchod nevěsty', description: 'Všichni povstanou. Nevěsta přichází s tatínkem.', participants: ['nevesta'], cue: 'Hudba: Wagner' },
  { id: 'cs3', wedding_id: '00000000-0000-0000-0000-000000000000', order_index: 3, step_name: 'Uvítání', description: 'Oddávající vítá snoubence a hosty.', participants: ['oddavajici'] },
  { id: 'cs4', wedding_id: '00000000-0000-0000-0000-000000000000', order_index: 4, step_name: 'Výměna prstýnků', description: 'Svědci podají prstýnky.', participants: ['zenich', 'nevesta', 'svedci'] },
  { id: 'cs5', wedding_id: '00000000-0000-0000-0000-000000000000', order_index: 5, step_name: 'Polibek', description: 'První novomanželský polibek.', participants: ['zenich', 'nevesta'] }
];

const SEED_CEREMONY_CHECKLIST = [
  { id: 'ccl1', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Zajistit termín na matrice', status: 'done' },
  { id: 'ccl2', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Ověřit platnost dokladů', status: 'done' },
  { id: 'ccl3', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Domluvit hudbu', status: 'todo' },
  { id: 'ccl4', wedding_id: '00000000-0000-0000-0000-000000000000', title: 'Koupit polštářek pod prstýnky', status: 'todo' }
];

const SEED_CEREMONY_MUSIC = [
  { id: 'cmusic1', wedding_id: '00000000-0000-0000-0000-000000000000', moment: 'prichod', track_name: 'Canon in D (Pachelbel)', responsible_person: 'DJ' },
  { id: 'cmusic2', wedding_id: '00000000-0000-0000-0000-000000000000', moment: 'odchod', track_name: 'Happy (Pharrell)', responsible_person: 'DJ' }
];

const SEED_MEMBERS = [
  { wedding_id: '00000000-0000-0000-0000-000000000000', user_id: 'debug-user-id', role: 'admin' }
];

const SEEDS: Record<string, any[]> = {
  weddings: SEED_WEDDINGS,
  guests: SEED_GUESTS,
  tasks: SEED_TASKS,
  schedule_items: SEED_SCHEDULE,
  activities: SEED_ACTIVITIES, // Added activities
  budget_items: SEED_BUDGET,
  vendors: SEED_VENDORS,
  tables: SEED_TABLES,
  table_assignments: SEED_ASSIGNMENTS,
  notes: SEED_NOTES,
  templates: SEED_TEMPLATES,
  wedding_members: SEED_MEMBERS,
  profiles: [{ id: 'debug-user-id', name: 'Vývojářský Režim', email: 'dev@marryplan.cz', language: 'cs', theme: 'system' }],
  // New tables
  ring_items: SEED_RINGS,
  ceremony_meta: SEED_CEREMONY_META,
  ceremony_contacts: SEED_CEREMONY_CONTACTS,
  ceremony_roles: SEED_CEREMONY_ROLES,
  ceremony_steps: SEED_CEREMONY_STEPS,
  ceremony_checklist: SEED_CEREMONY_CHECKLIST,
  ceremony_music: SEED_CEREMONY_MUSIC
};

// --- MOCK DB & QUERY BUILDER ---

class MockQueryBuilder {
  constructor(
    private table: string,
    private data: any[]
  ) {}

  private filters: ((item: any) => boolean)[] = [];
  private sort: { col: string, ascending: boolean } | null = null;
  private limitCount: number | null = null;

  select(columns = '*') {
    return this;
  }

  eq(column: string, value: any) {
    this.filters.push(item => item[column] === value);
    return this;
  }

  neq(column: string, value: any) {
    this.filters.push(item => item[column] !== value);
    return this;
  }

  lt(column: string, value: any) {
    this.filters.push(item => item[column] < value);
    return this;
  }
  
  gt(column: string, value: any) {
    this.filters.push(item => item[column] > value);
    return this;
  }

  in(column: string, values: any[]) {
    this.filters.push(item => values.includes(item[column]));
    return this;
  }

  order(column: string, { ascending = true } = {}) {
    this.sort = { col: column, ascending };
    return this;
  }

  limit(count: number) {
    this.limitCount = count;
    return this;
  }

  single() {
    return this.then(data => {
      if (!data || data.length === 0) return { data: null, error: { message: 'No rows found' } };
      return { data: data[0], error: null };
    });
  }

  async insert(rowOrRows: any) {
    const rows = Array.isArray(rowOrRows) ? rowOrRows : [rowOrRows];
    const newRows = rows.map((r: any) => ({
      ...r,
      id: r.id || crypto.randomUUID(),
      created_at: new Date().toISOString()
    }));
    
    const current = getStorage(this.table);
    const updated = [...current, ...newRows];
    setStorage(this.table, updated);
    
    return { data: newRows, error: null };
  }

  update(updates: any) {
    const builder = new MockMutationBuilder(this.table, this.data, 'UPDATE', updates);
    return builder;
  }

  delete() {
    const builder = new MockMutationBuilder(this.table, this.data, 'DELETE');
    return builder;
  }

  // Promise interface
  then(resolve: any, reject?: any) {
    let result = this.data;
    
    // Refresh data from storage to be sure
    result = getStorage(this.table);

    for (const filter of this.filters) {
      result = result.filter(filter);
    }

    if (this.sort) {
      const { col, ascending } = this.sort;
      result.sort((a, b) => {
        if (a[col] < b[col]) return ascending ? -1 : 1;
        if (a[col] > b[col]) return ascending ? 1 : -1;
        return 0;
      });
    }

    if (this.limitCount !== null) {
      result = result.slice(0, this.limitCount);
    }

    return Promise.resolve({ data: result, error: null }).then(resolve, reject);
  }
}

class MockMutationBuilder {
  private filters: ((item: any) => boolean)[] = [];
  
  constructor(
    private table: string,
    private data: any[],
    private type: 'UPDATE' | 'DELETE',
    private updates?: any
  ) {}

  eq(column: string, value: any) {
    this.filters.push(item => item[column] === value);
    return this;
  }
  
  in(column: string, values: any[]) {
    this.filters.push(item => values.includes(item[column]));
    return this;
  }

  select() { return this; } // No-op

  then(resolve: any, reject?: any) {
    let current = getStorage(this.table);
    let affected = 0;

    if (this.type === 'DELETE') {
      const initialLen = current.length;
      current = current.filter(item => {
        const matches = this.filters.every(f => f(item));
        return !matches;
      });
      affected = initialLen - current.length;
    } else if (this.type === 'UPDATE' && this.updates) {
      current = current.map(item => {
        const matches = this.filters.every(f => f(item));
        if (matches) {
          affected++;
          return { ...item, ...this.updates };
        }
        return item;
      });
    }

    setStorage(this.table, current);
    return Promise.resolve({ data: affected > 0 ? [this.updates] : [], error: null }).then(resolve, reject);
  }
}

function getStorage(key: string) {
  try {
    const k = `wp_mock_${key}`;
    const val = localStorage.getItem(k);
    if (!val && SEEDS[key]) {
      localStorage.setItem(k, JSON.stringify(SEEDS[key]));
      return SEEDS[key];
    }
    return val ? JSON.parse(val) : [];
  } catch { return []; }
}

function setStorage(key: string, data: any[]) {
  try {
    localStorage.setItem(`wp_mock_${key}`, JSON.stringify(data));
  } catch {}
}

export const createMockClient = () => {
  return {
    from: (table: string) => new MockQueryBuilder(table, getStorage(table)),
    auth: {
      getUser: async () => ({ data: { user: { id: 'debug-user-id', email: 'dev@marryplan.cz' } }, error: null }),
      signOut: async () => { window.location.reload(); },
      onAuthStateChange: () => ({ data: { subscription: { unsubscribe: () => {} } } })
    }
  };
};
